import { useFadeUp } from '../hooks/usefadeup'
import {
  FiEye, FiTarget, FiShield,
  FiCpu, FiBriefcase, FiGlobe, FiUsers,
} from 'react-icons/fi'
import './Valores.css'

const valuesList = [
  { name: 'Integridade', icon: FiShield },
  { name: 'Inovação', icon: FiCpu },
  { name: 'Profissionalismo', icon: FiBriefcase },
  { name: 'Responsabilidade Social', icon: FiGlobe },
  { name: 'Foco no Cliente', icon: FiUsers },
]

export default function Valores() {
  const ref = useFadeUp<HTMLElement>()

  return (
    <section id="valores" className="vl" ref={ref}>
      <div className="vl-container">

        {/* Header */}
        <div className="vl-header" data-fade data-fade-delay="0">
          <h2 className="vl-title">
            O que nos define
          </h2>
        </div>

        {/* 3-Column Grid */}
        <div className="vl-grid">

          {/* Card 1: Visão */}
          <div className="vl-card" data-fade data-fade-delay="100">
            <span className="vl-card-tag">Visão</span>
            <div className="vl-card-icon-wrapper">
              <FiEye className="vl-card-icon" />
            </div>
            <h3 className="vl-card-title">Excelência que transcende fronteiras</h3>
            <p className="vl-card-body">
              Consolidar-nos como a corretora de seguros de referência em Moçambique, distinguida pela excelência operacional, confiança e capacidade de oferecer soluções alinhadas aos melhores padrões globais.
            </p>
          </div>

          {/* Card 2: Missão */}
          <div className="vl-card" data-fade data-fade-delay="180">
            <span className="vl-card-tag">Missão</span>
            <div className="vl-card-icon-wrapper">
              <FiTarget className="vl-card-icon" />
            </div>
            <h3 className="vl-card-title">Parceiro certo em Moçambique</h3>
            <p className="vl-card-body">
              Ser parceiro de referência, oferecendo as melhores soluções de seguros com cobertura abrangente, protegendo pessoas e negócios em toda a amplitude de riscos do mercado.
            </p>
          </div>

          {/* Card 3: Valores */}
          <div className="vl-card" data-fade data-fade-delay="260">
            <span className="vl-card-tag">Valores</span>
            <div className="vl-card-icon-wrapper">
              <FiShield className="vl-card-icon" />
            </div>
            <h3 className="vl-card-title">O que nos identifica neste ramo</h3>

            <ul className="vl-list">
              {valuesList.map(({ name, icon: Icon }, i) => (
                <li
                  key={name}
                  className="vl-item"
                  style={{ '--d': `${i * 60}ms` } as React.CSSProperties}
                >
                  <span className="vl-item-bullet-wrapper">
                    <Icon className="vl-item-icon" aria-hidden="true" />
                  </span>
                  <span className="vl-item-name">{name}</span>
                </li>
              ))}
            </ul>
          </div>

        </div>
      </div>
    </section>
  )
}